import { RouteHandlerObject } from 'workbox-core/types.js';
import { Route } from 'workbox-routing';
import { getOrCreateDefaultRouter } from 'workbox-routing/utils/getOrCreateDefaultRouter';
import { Strategy } from 'workbox-strategies';

declare const self: ServiceWorkerGlobalScope;

function _isRouteHandlerObject(object: unknown): object is RouteHandlerObject {
    if (!object || typeof object !== 'object') {
        return false;
    }

    const record: Partial<RouteHandlerObject> = object as Partial<RouteHandlerObject>;

    const isNullOrUndefined = (value: unknown) => value === null || value === undefined;

    return !isNullOrUndefined(record?.handle) && typeof record?.handle === 'function';
}

function _isStrategy(object: unknown): object is Strategy {
    if (!_isRouteHandlerObject(object)) {
        return false;
    }

    const record: Partial<Strategy> = object as Partial<Strategy>;

    const isNullOrUndefined = (value: unknown) => value === null || value === undefined;

    return !isNullOrUndefined(record?.cacheName) && !isNullOrUndefined(record?.plugins);
}

function findResponderStrategy(urlFetch: string, event?: ExtendableEvent): Strategy | null {
    const router = getOrCreateDefaultRouter();

    const request = new Request(urlFetch);
    const url = new URL(urlFetch, self.location.href);
    const sameOrigin = url.origin === self.location.origin;

    const routeMatchOptions = {
        request,
        url,
        sameOrigin,
        event: event ?? new ExtendableEvent('fetch'),
    };

    const { route } = router.findMatchingRoute(routeMatchOptions);

    if (route?.handler && _isStrategy(route?.handler)) {
        return route.handler;
    }

    return null;
}

function routes(): Array<Route> {
    const router = getOrCreateDefaultRouter();

    const routes = Array.from(router.routes.entries()).flatMap(entry => entry[1]);

    return routes;
}

const module = {
    findResponderStrategy,
    routes,
};

export default module;
